import React, { useEffect, useState } from "react";
import { Container, Card } from "react-bootstrap";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import { getDocs, collection } from "firebase/firestore/lite";
import { db } from "../firebase/firebase-config";
import { message } from "antd";

const PaymentDetails = () => {
  const [paymentList, setPaymentList] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    fetchPayments();
  }, []);

  async function fetchPayments() {
    try {
      setIsLoading(true);
      const paymentsCollectionRef = collection(db, "sacco", "TEKiK01inpRB3NFlK65S", "payments");
      const paymentSnapshot = await getDocs(paymentsCollectionRef);
      const fetchedPayments = paymentSnapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));
      setPaymentList(fetchedPayments);
    } catch (err) {
      message.error("Error fetching payments: " + err.message);
    } finally {
      setIsLoading(false);
    }
  }

  return (
    <>
      <Navbar />
      <Container className="py-5">
        <h2 className="text-center mb-4">Payment Details</h2>

        {/* Accepted Payment Methods */}
        <Card className="p-4 shadow-lg">
          <h3 className="text-2xl font-semibold text-gray-800 text-center mb-4">Accepted Payment Methods</h3>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
            {isLoading ? (
              <p className="text-center">Loading payment methods...</p>
            ) : paymentList.length > 0 ? (
              paymentList.map((method, index) => (
                <div key={index} className="p-6 bg-white rounded-lg shadow-lg text-center">
                  <img src={method.img || "/assets/default.jpg"} alt={method.method} className="w-full h-48 object-cover rounded-md mb-4" />
                  <h3 className="text-xl font-semibold text-gray-800">{method.method}</h3>
                  <p className="text-gray-600">{method.details}</p>
                </div>
              ))
            ) : (
              <p className="text-center text-gray-500">No payment methods available.</p>
            )}
          </div>
        </Card>
      </Container>
      <Footer />
    </>
  );
};

export default PaymentDetails;
